/**
 * Collection Amorf Banner — sade çizgi + yumuşak morph
 * Dikdörtgen → 12 burç → döngü. Renk YOK, sadece outline stroke.
 * Animation: per-frame polar radii interpolation (rAF 60fps, easeInOut), HOLD 2400ms + MORPH 900ms.
 * Chevron → accordion açar (inline HTML, fetch yok) + lazy-load amorf-banner.js.
 */
(function () {
  'use strict';

  var STATES = [
    { kind: 'rect', label: 'Dikdörtgen' },
    { kind: 'amorf', label: 'Koç Burcu',     radii: [0.72, 0.86, 1.00, 0.96, 0.78, 0.55, 0.45, 0.50, 0.60, 0.76, 0.88, 0.92, 0.88, 0.82, 0.78, 0.74] },
    { kind: 'amorf', label: 'Boğa Burcu',    radii: [0.82, 0.88, 1.00, 0.98, 0.92, 0.88, 0.85, 0.88, 0.92, 0.95, 0.98, 0.95, 0.90, 0.85, 0.82, 0.80] },
    { kind: 'amorf', label: 'İkizler Burcu', radii: [0.96, 0.88, 0.76, 0.68, 0.72, 0.82, 0.92, 0.96, 0.96, 0.88, 0.76, 0.68, 0.72, 0.82, 0.92, 0.96] },
    { kind: 'amorf', label: 'Yengeç Burcu',  radii: [0.88, 0.96, 0.92, 0.75, 0.58, 0.47, 0.48, 0.52, 0.62, 0.75, 0.88, 0.96, 0.98, 0.96, 0.92, 0.90] },
    { kind: 'amorf', label: 'Aslan Burcu',   radii: [0.95, 1.00, 0.98, 0.88, 0.78, 0.85, 0.90, 0.88, 0.82, 0.88, 0.90, 0.85, 0.78, 0.88, 0.98, 1.00] },
    { kind: 'amorf', label: 'Başak Burcu',   radii: [0.90, 0.92, 0.90, 0.85, 0.82, 0.85, 0.90, 0.92, 0.92, 0.90, 0.85, 0.82, 0.85, 0.90, 0.92, 0.90] },
    { kind: 'amorf', label: 'Terazi Burcu',  radii: [0.90, 0.88, 0.95, 1.00, 0.95, 0.82, 0.72, 0.75, 0.78, 0.75, 0.72, 0.82, 0.95, 1.00, 0.95, 0.88] },
    { kind: 'amorf', label: 'Akrep Burcu',   radii: [0.88, 0.92, 0.85, 0.78, 0.82, 0.90, 0.88, 0.82, 0.75, 0.65, 0.40, 0.30, 0.36, 0.56, 0.76, 0.85] },
    { kind: 'amorf', label: 'Yay Burcu',     radii: [0.68, 0.82, 0.95, 1.00, 0.92, 0.78, 0.62, 0.55, 0.60, 0.72, 0.85, 0.92, 0.88, 0.80, 0.72, 0.68] },
    { kind: 'amorf', label: 'Oğlak Burcu',   radii: [0.85, 0.90, 0.88, 0.82, 0.78, 0.72, 0.68, 0.60, 0.55, 0.50, 0.60, 0.75, 0.88, 0.92, 0.90, 0.88] },
    { kind: 'amorf', label: 'Kova Burcu',    radii: [0.86, 0.94, 0.82, 0.90, 0.78, 0.92, 0.82, 0.94, 0.86, 0.94, 0.82, 0.90, 0.78, 0.92, 0.82, 0.94] },
    { kind: 'amorf', label: 'Balık Burcu',   radii: [0.92, 0.96, 0.88, 0.75, 0.70, 0.82, 0.92, 0.95, 0.92, 0.88, 0.75, 0.70, 0.82, 0.88, 0.95, 0.92] }
  ];

  var HOLD_MS = 2400;
  var MORPH_MS = 900;

  function easeInOut(t) {
    return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
  }

  function lerp(a, b, t) { return a + (b - a) * t; }

  function interpolateRadii(a, b, t) {
    var out = new Array(a.length);
    for (var i = 0; i < a.length; i++) out[i] = lerp(a[i], b[i], t);
    return out;
  }

  // Rect: proper sharp-cornered rounded rectangle (ctx.rect tarzı)
  function drawRectShape(ctx, w, h, alpha) {
    var rw = w * 0.72, rh = h * 0.66;
    var x = (w - rw) / 2, y = (h - rh) / 2;
    var rad = 3;
    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.strokeStyle = '#1a1a2e';
    ctx.lineWidth = 1.5;
    ctx.lineJoin = 'miter';
    ctx.lineCap = 'round';
    ctx.beginPath();
    ctx.moveTo(x + rad, y);
    ctx.lineTo(x + rw - rad, y);
    ctx.quadraticCurveTo(x + rw, y, x + rw, y + rad);
    ctx.lineTo(x + rw, y + rh - rad);
    ctx.quadraticCurveTo(x + rw, y + rh, x + rw - rad, y + rh);
    ctx.lineTo(x + rad, y + rh);
    ctx.quadraticCurveTo(x, y + rh, x, y + rh - rad);
    ctx.lineTo(x, y + rad);
    ctx.quadraticCurveTo(x, y, x + rad, y);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
  }

  // Amorf: Catmull-Rom 16-nokta polar, closed-spline stroke
  function drawAmorfShape(ctx, w, h, radii, alpha) {
    var cx = w / 2, cy = h / 2;
    var scaleX = w * 0.44;
    var scaleY = h * 0.40;
    var n = radii.length;
    var pts = [];
    for (var i = 0; i < n; i++) {
      var a = (i / n) * Math.PI * 2 - Math.PI / 2;
      pts.push({ x: cx + Math.cos(a) * radii[i] * scaleX, y: cy + Math.sin(a) * radii[i] * scaleY });
    }
    var t = 0.28;
    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.strokeStyle = '#1a1a2e';
    ctx.lineWidth = 1.5;
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.beginPath();
    ctx.moveTo(pts[0].x, pts[0].y);
    for (var j = 0; j < n; j++) {
      var p0 = pts[(j - 1 + n) % n];
      var p1 = pts[j];
      var p2 = pts[(j + 1) % n];
      var p3 = pts[(j + 2) % n];
      var c1x = p1.x + (p2.x - p0.x) * t;
      var c1y = p1.y + (p2.y - p0.y) * t;
      var c2x = p2.x - (p3.x - p1.x) * t;
      var c2y = p2.y - (p3.y - p1.y) * t;
      ctx.bezierCurveTo(c1x, c1y, c2x, c2y, p2.x, p2.y);
    }
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
  }

  // Tek state (morph yok) için
  function drawState(ctx, w, h, state) {
    ctx.clearRect(0, 0, w, h);
    if (state.kind === 'rect') drawRectShape(ctx, w, h, 1);
    else drawAmorfShape(ctx, w, h, state.radii, 1);
  }

  // Morph frame: iki state arası geçiş
  // rect↔amorf: crossfade (alpha).  amorf↔amorf: polar radii interpolation.
  function drawMorphFrame(ctx, w, h, cur, next, t) {
    ctx.clearRect(0, 0, w, h);
    if (cur.kind === 'rect' && next.kind === 'amorf') {
      drawRectShape(ctx, w, h, 1 - t);
      drawAmorfShape(ctx, w, h, next.radii, t);
    } else if (cur.kind === 'amorf' && next.kind === 'rect') {
      drawAmorfShape(ctx, w, h, cur.radii, 1 - t);
      drawRectShape(ctx, w, h, t);
    } else if (cur.kind === 'amorf' && next.kind === 'amorf') {
      var interp = interpolateRadii(cur.radii, next.radii, t);
      drawAmorfShape(ctx, w, h, interp, 1);
    } else {
      // rect → rect (shouldn't happen in STATES sırasında ama güvenlik için)
      drawRectShape(ctx, w, h, 1);
    }
  }

  function setupCanvas(canvas) {
    var w = canvas.offsetWidth || canvas.width;
    var h = canvas.offsetHeight || canvas.height;
    var dpr = window.devicePixelRatio || 1;
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    canvas.style.width = w + 'px';
    canvas.style.height = h + 'px';
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    return { ctx: ctx, w: w, h: h };
  }

  function initBanner(el) {
    var canvas = el.querySelector('.dv-cab__canvas');
    var subEl = el.querySelector('[data-dv-sub]');
    if (!canvas || !subEl) return;

    var s = setupCanvas(canvas);
    var ctx = s.ctx, w = s.w, h = s.h;

    var curIdx = 0;
    var nextIdx = 1;
    var phase = 'HOLD'; // 'HOLD' | 'MORPH'
    var phaseStart = 0;
    var running = true;
    var rafId = null;

    function updateSub(idx) {
      subEl.textContent = STATES[idx].label + ' · Tıkla Keşfet →';
    }
    updateSub(curIdx);
    drawState(ctx, w, h, STATES[curIdx]);

    function frame(now) {
      if (!running) { rafId = null; return; }
      if (!phaseStart) phaseStart = now;
      var elapsed = now - phaseStart;
      if (phase === 'HOLD') {
        drawState(ctx, w, h, STATES[curIdx]);
        if (elapsed >= HOLD_MS) {
          phase = 'MORPH';
          phaseStart = now;
        }
      } else {
        var t = Math.min(elapsed / MORPH_MS, 1);
        drawMorphFrame(ctx, w, h, STATES[curIdx], STATES[nextIdx], easeInOut(t));
        if (t >= 1) {
          curIdx = nextIdx;
          nextIdx = (nextIdx + 1) % STATES.length;
          phase = 'HOLD';
          phaseStart = now;
          updateSub(curIdx);
        }
      }
      rafId = requestAnimationFrame(frame);
    }
    rafId = requestAnimationFrame(frame);

    function pause() {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;
    }
    function resume() {
      if (running) return;
      running = true;
      phaseStart = 0;
      rafId = requestAnimationFrame(frame);
    }

    // Toggle
    var toggle = el.querySelector('[data-dv-toggle]');
    var panel = el.querySelector('[data-dv-panel]');
    if (!toggle || !panel) return;

    function setOpen(open) {
      el.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) {
        pause();
        ensureAmorfJs(el, panel);
      } else {
        resume();
        var r = el.getBoundingClientRect();
        if (r.top < 0) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    toggle.addEventListener('click', function () { setOpen(!el.classList.contains('is-open')); });
    // Header tüm alan tıklanabilir olsun (daha çekici)
    var body = el.querySelector('.dv-cab__body');
    if (body) {
      body.addEventListener('click', function (e) {
        if (e.target.closest('[data-dv-toggle]')) return; // zaten toggle click
        setOpen(!el.classList.contains('is-open'));
      });
    }
    var closeBtn = el.querySelector('[data-dv-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });
  }

  function ensureAmorfJs(rootEl, panel) {
    if (window.__DV_AMORF_BANNER_LOADED) {
      selectQualityTab(panel, rootEl.getAttribute('data-quality') || 'paradiso');
      return;
    }
    var jsUrl = rootEl.getAttribute('data-amorf-js');
    if (!jsUrl) return;
    window.__DV_AMORF_BANNER_LOADED = true;
    var sc = document.createElement('script');
    sc.src = jsUrl;
    sc.onload = function () {
      selectQualityTab(panel, rootEl.getAttribute('data-quality') || 'paradiso');
    };
    document.head.appendChild(sc);
  }

  function selectQualityTab(panel, quality) {
    setTimeout(function () {
      var sel = [
        '.dvb-ab-tab[data-q="' + quality + '"]',
        '.dvb-ab-tab[data-quality="' + quality + '"]',
        'button[data-q="' + quality + '"]'
      ].join(',');
      var tab = panel.querySelector(sel);
      if (tab && typeof tab.click === 'function') tab.click();
    }, 250);
  }

  function boot() {
    document.querySelectorAll('[data-dv-cab]').forEach(initBanner);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
